// src/features/auth/Signup.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
import { db } from "../../shared/services/firebase";
import { doc, setDoc } from "firebase/firestore";
import { v4 as uuidv4 } from "uuid";
import "./AuthForm.css";

const Signup = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleSignup = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    const auth = getAuth();
    try {
      // 1. Create the user
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      // 2. Generate a UUID
      const userUuid = uuidv4();
      // 3. Store in Firestore under user's UID
      await setDoc(doc(db, "users", user.uid), {
        email: user.email,
        uuid: userUuid,
        createdAt: new Date()
      });
      // 4. Redirect to dashboard or wherever you want
      navigate("/select-form");
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-form-container">
      <h2 className="auth-form-title">Sign Up</h2>
      <form className="auth-form" onSubmit={handleSignup}>
        <div className="auth-form-group">
          <label htmlFor="signup-email">Email</label>
          <input
            id="signup-email"
            type="email"
            placeholder="Email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            className="auth-form-input"
            required
          />
        </div>
        <div className="auth-form-group">
          <label htmlFor="signup-password">Password</label>
          <input
            id="signup-password"
            type="password"
            placeholder="Password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            className="auth-form-input"
            required
          />
        </div>
        {error && <div className="auth-form-error">{error}</div>}
        <button className="auth-form-submit" type="submit" disabled={submitting}>
          {submitting ? "Signing Up..." : "Sign Up"}
        </button>
      </form>
      <p className="auth-form-alt-link">
        Already have an account? <a href="/login">Log In</a>
      </p>
    </div>
  );
};

export default Signup;
